import React from 'react';

import contacteImage from '../../assets/images/contacte.jpg';
import { PageTitle, WideContentContainer } from '../Shared/CommonStyles';

import * as S from './Contacte.styles';

const Contacte: React.FC = () => {
	return (
		<WideContentContainer>
			<PageTitle>Contacte</PageTitle>
			<S.ContentWrapper>
				<S.LeftColumn>
					<S.ContactImage
						src={contacteImage}
						alt="Contacte"
					/>
				</S.LeftColumn>
				<S.RightColumn>
					<S.ContactTitle><strong>Contacta amb nosaltres</strong></S.ContactTitle>
					<S.ContactDetail>
						Escriu-nos a{' '}
						<a href="mailto:santnarcis@escoltesiguies.cat">
							santnarcis@escoltesiguies.cat
						</a>
					</S.ContactDetail>
					<S.ContactTitle><strong>Vine&apos;ns a veure</strong></S.ContactTitle>
					<S.ContactDetail>
						Fem cau els dissabtes a la tarda a Carrer de Sant Gregori, 93, 9, 11,
						de les 16:00h a les 19:00h.
					</S.ContactDetail>
					<S.MapWrapper>
						<S.MapIframe
							src="https://maps.google.com/maps?q=41.991901338020085,2.809523393162478&output=embed"
							allowFullScreen
							loading="lazy"
							title="Localització del cau"
						/>
					</S.MapWrapper>
				</S.RightColumn>
				<S.CaptionRow>
					<S.Caption>
						Posició del cau en relació als punts més importants
						de Catalunya.
					</S.Caption>
				</S.CaptionRow>
			</S.ContentWrapper>
		</WideContentContainer>
	);
};

export default Contacte;
